import type { BaseTranslation } from '../i18n-types';

export const income = {
    myIncome: 'My income',
    description: 'Your earnings will be transferred for withdrawal every Monday at 00:00 UTC once the minimum balance has been reached. Money will be sent to your payment details on Tuesday.',
    total: 'Total Balance',
    weeklyEarnings: 'Weekly earnings',
    chatCallsGifts: 'Random/Direct calls, Gifts',
    referrals: 'Referrals',
    weeklyBonus: 'Weekly Bonus for Top-100 models',
    yourRanking: 'Your ranking',
    rulesAndPrizes: 'Rules and prizes',
    na: 'n/a',
    rankingDescription: 'Your ranking is based on your weekly earnings from Random/Direct calls, and Gifts. The earnings from previous weeks are not included in the ranking. The more you earn, the higher your ranking.',
    rankingAndRewards: 'Rankings and rewards:',
    rankingUpdate: 'Your ranking is updated once per minute. Every Monday at 00:00 UTC, the contest will end and start over.',
    netTotal: 'Net Income',
    paymentDetailsInfo: 'Please specify preferable payment method. Otherwise we won\'t be able to make payouts for you.',
    paymentDetailsInvalid: '<b>Payout failed.</b> We were unable to make a payment based on the specified details. Please correct the payment details or contact us at <a class="link" href="mailto:{supportEmail:string}">{supportEmail:string}</a>',
    weeklyBonusText:
        'Weekly bonus is a cash bonus – ${bonus} paid ' +
        'in addition to your total income.' +
        '<br/><br/>' +
        'To get this bonus, you need to spend ' +
        'at least {minutes} minutes chatting during ' +
        'the week (from Monday to Sunday). You ' +
        'do not need to spend every day chatting, ' +
        'you just need to collect required amount ' +
        'of minutes during the 7 day period.',
    currentMinutesAndBonus: 'Bonus progress (minutes)',
    conditions: 'Conditions and rates',
    rate: 'Rate',
    rateTooltip: `You will get \${firstMinute} for the first minute of conversation and \${secondMinute} for every subsequent minute`,
    rateTooltipV2: `First minute (free user): \${firstMinute}<br/>First minute (premium): \${firstMinutePremium}<br/>Second minute onwards: \${secondMinute}`,
    withdraw: 'Minimal withdraw',
    agentFee: 'Agent fee',
    withdrawTooltip: 'The minimum payout amount is {value:string}. If your account has less than {value:string} during 7 days, the sum you have will be transferred to the next week. Please note that it may take several days for your bank to credit your account.',
    feeTooltip: 'A withdrawal fee will be deducted from the displayed amount. The sum may vary slightly but it is estimated to be around 1% of the amount you want to withdraw. This fee covers the transaction costs and will be taken from the payment sum before it reaches your wallet.',
    minuteCost: 'Minute cost',
    weeklyContest: 'Weekly contest',
    giftCosts: 'Gift coasts',
    contest: '{name:string} contest',
    minWithdraw: 'Minimum withdraw: {value:string}. We pay every Tuesday.',
    paymentHistoryTitle: 'Payment History',
    paymentHistoryDescription: 'Your payment history will appear here once you receive your first payout',
    table: {
        dateColumn: 'Date',
        payoutMethodColumn: 'Payout method',
        statusColumn: 'Status',
        earningsColumn: 'Earnings',
        feeColumn: 'Payout fee',
        payoutColumn: 'Payout',
        totalRow: 'Total',
    },
    earningsAndStatistics: 'Earnings & Statistics',
    payoutError: {
        accountNotVerified: 'Account is not verified',
        duplicatePaymentDetails: 'Duplicate payment details',
        beneficiaryNotFound: 'Beneficiary is not found',
        invalidIban: 'Invalid IBAN',
        invalidWalletAddress: 'Invalid wallet address',
        ibanNoSepaSupport: 'This IBAN does not support SEPA payments',
        modelRequest: 'Model request',
        other: 'Other',
        insufficientFunds: 'Insufficient funds',
        paymentDenied: 'Payment Denied',
    },
    penalty: 'Penalty',
    transactionStatus: {
        pending: 'Pending',
        done: 'Paid',
        error: 'Failed',
    },
} satisfies BaseTranslation;
